import {FilterType} from '../utils/const';
import Component from './component';

const createTripFiltersTemplate = (currentFilterType, filtredEventsIsEmpty) => {
  return (
    `<form class="trip-filters" action="#" method="get">
      <div class="trip-filters__filter">
        <input
          id="filter-everything"
          class="trip-filters__filter-input  visually-hidden"
          type="radio" name="trip-filter"
          value="everything"
          ${currentFilterType === FilterType.EVERYTHING ? `checked` : ``}
          ${filtredEventsIsEmpty[FilterType.EVERYTHING] ? `` : `disabled`}>
        <label class="trip-filters__filter-label" for="filter-everything">Everything</label>
      </div>

      <div class="trip-filters__filter">
        <input id="filter-future"
          class="trip-filters__filter-input  visually-hidden"
          type="radio"
          name="trip-filter"
          value="future"
          ${currentFilterType === FilterType.FUTURE ? `checked` : ``}
          ${filtredEventsIsEmpty[FilterType.FUTURE] ? `` : `disabled`}>
        <label class="trip-filters__filter-label" for="filter-future">Future</label>
      </div>

      <div class="trip-filters__filter">
        <input
          id="filter-past"
          class="trip-filters__filter-input  visually-hidden"
          type="radio"
          name="trip-filter"
          value="past"
          ${currentFilterType === FilterType.PAST ? `checked` : ``}
          ${filtredEventsIsEmpty[FilterType.PAST] ? `` : `disabled`}>
        <label class="trip-filters__filter-label" for="filter-past">Past</label>
      </div>

      <button class="visually-hidden" type="submit">Accept filter</button>
    </form>`
  );
};

export default class TripFiltersView extends Component {
  constructor(currentFilterType, filtredEventsIsEmpty) {
    super();

    this._currentFilter = currentFilterType;
    this._filtredEventsIsEmpty = filtredEventsIsEmpty;

    this._filterTypeChangeHandler = this._filterTypeChangeHandler.bind(this);
  }

  getTemplate() {
    return createTripFiltersTemplate(this._currentFilter, this._filtredEventsIsEmpty);
  }

  setFilterTypeChangeHandler(callback) {
    this._callback.filterTypeChange = callback;
    this.getElement().addEventListener(`change`, this._filterTypeChangeHandler);
  }

  _filterTypeChangeHandler(evt) {
    evt.preventDefault();
    this._callback.filterTypeChange(evt.target.value);
  }
}
